import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { logError } from "@/lib/logger";
import { toast } from "sonner";

export default function MagicLinkVerify() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("invalid"); return; }
    (async () => {
      try {
        const { data } = await api.get(`/auth/magic/verify?token=${encodeURIComponent(token)}`);
        // Cookie is set server-side (httpOnly) — just refresh the auth context.
        await refresh();
        toast.success("Autenticado!");
        nav(data.user.role === "admin" ? "/admin" : "/minha-conta");
      } catch (e) {
        logError("[magic-link] verify failed:", e);
        setStatus("invalid");
        toast.error(e.response?.data?.detail || "Link inválido");
      }
    })();
    // Params/refresh/nav are stable across renders; effect must only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center">
        <div className="font-heading font-black text-2xl">{status === "verifying" ? "Verificando…" : "Link inválido"}</div>
        {status === "invalid" && <a href="/login" className="text-sm underline mt-4 inline-block">Voltar ao login</a>}
      </div>
    </div>
  );
}
